import { useTranslation } from 'react-i18next';
import React, {useEffect, useState, Fragment,} from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Typography,Box,Table,TableRow,TableBody,TableHead,TableContainer,TableCell,IconButton,Tooltip,Button,Grid} from '@mui/material'
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { useMessage } from "../../context/message-context";
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import openFile from "../shared/functions/download";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import {FullPageSpinner} from '../lib';
import StammformularVertrag from '../StammformularVertragComponent';
import { Routes, Route} from "react-router-dom";
function StammblattMonitor(props) {
  const { t } = useTranslation();
  const {client, accessToken, userid, admin, updateTitle,} = props;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [daten, setDaten] = useState([]);
  const {hideMessage, showErrorMessage} = useMessage();
  const [showModal, setShowModal] = useState(false);
//Laden der daten bei öffnen der Seite
  useEffect(() => {
    Hole_Tickets();
      // eslint-disable-next-line
  }, [])
  
  const Hole_Tickets = () => {
    setIsLoading(true);
    const payload={
      "mandant": client,
      "program": "LPB1AP",
      "statement": "TICKETS_HOLEN",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, ticketCB);    
  }
  const ticketCB = (response) => {
    if (response.status === 200) {
      if (response.data.tickets) {
          setDaten(response.data.tickets);
      } else {
          setDaten([]);
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const downloadFile = (key,aktion,datname) => {
    console.log('file with key: ', key);
    const payload={
        "mandant": client, 
        "program": "LPB1AP",
        "statement": "PDF_ANZEIGEN",
        "key": key,
        "aktion":aktion,
    }
    const headers={
        "Authorization": "Bearer "+accessToken,
        "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
      .then((response) => {
        console.log(response);
        var fileName = datname+".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  }
  const ticktanzeigen = daten.map((element) => {
    return (
      <Fragment>
        <TableRow>
          <TableCell>{element.annr}</TableCell>
          <TableCell>{element.anlage}</TableCell>
          <TableCell>
            { element.fehlend==="1" ?      
              <AssignmentLateIcon style={{color:"rgba("+element.farbe+" ,0.8)"}}/>
             : 
              <AssignmentTurnedInIcon style={{color:"rgba("+element.farbe+" ,0.8)"}}/>
            }
            {element.status}
          </TableCell>
          <TableCell>
            <Tooltip title={t("fehlende Angaben anzeigen")}>
              <IconButton color="primary" disabled={!element.fehlend} onClick={() => {downloadFile(element.key,"fehlend","Stammblatt - fehlende Daten " + element.anname)}} ><InfoIcon/></IconButton>
            </Tooltip>
            <Tooltip title={t("Stammformular bearbeiten")} >
              <IconButton color="primary"  onClick={() => { navigate("/STAMBO/"+element.key, { state: { programm: 'LPB1AP'}})}} ><EditIcon/></IconButton>
            </Tooltip>
            <Tooltip title={t("Arbeitsvertrag drucken")} >
              <IconButton color="primary" onClick={() => { navigate("/LPB1AP/vertrag/"+element.key)}}  ><PrintIcon/></IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      </Fragment>
    )  
  })
  if (isLoading) {
    return <LoadingComponent />
  }
  const closeModal = () => {
    setShowModal(false);
  }
  const zeichnen = () => {
    return (
      <Page>
      <Layout>
        <Box pl={2} pr={2} pt={1} pb={1}>
            <Typography variant="h6">{t("Online-Stammformulare verwalten")}</Typography>
        </Box>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={6} >
                <Button fullWidth color="primary" variant="contained" onClick={() =>     navigate("/interview/IV0059",{state: { programm: "LPB1AP", }})} >{t("Neuen Arbeitnehmer anlegen")}</Button>
              </Grid>
              <Grid item xs={12}>
                <TableContainer>
                  <Table> 
                    <TableHead>
                    <TableRow>
                      <TableCell>{t("Arbeitnehmer")}</TableCell>
                      <TableCell>{t("Anlagedatum")}</TableCell>
                      <TableCell>{t("Status")}</TableCell>
                      <TableCell>{t("Aktionen")}</TableCell>
                    </TableRow>
                    </TableHead>           
                    <TableBody>
                    {ticktanzeigen}
                    </TableBody> 
                  </Table>
                </TableContainer>
              </Grid>
            </Grid> 
          </Grid> 
        </Grid> 
      </Layout>
      {showModal && <FullPageSpinner/>}
      </Page>
    );  
  }
return(
  <Routes>
    <Route path="/vertrag/:stammblattid" element={<StammformularVertrag updateTitle={(t) => updateTitle(t)} client={client} accessToken={accessToken} admin={admin} userid={userid}/>}/>  
    <Route path="/" element={zeichnen()}/>
  </Routes>
  )
}
export default StammblattMonitor; 
